export default "__VITE_ASSET__a3d9a594__"